<template>
  <main>
    <!-- HEADER WITH SWITCH AND NEW USER BUTTON -->
    <header>
      <div class="tabs">
        <span
          class="tab"
          :class="{ 'tab-active': tab === 'users' }"
          @click="tab = 'users'"
          >всички потребители</span
        >
        <span
          class="tab"
          :class="{ 'tab-active': tab === 'groups' }"
          @click="tab = 'groups'"
          >ГРУПИ/БРИГАДИ</span
        >
        <span
          class="tab"
          :class="{ 'tab-active': tab === 'positions' }"
          @click="tab = 'positions'"
          >ДЛЪЖНОСТИ/СТАВКИ</span
        >
      </div>
      <!-- ACTIVE/INACTIVE SWITCH -->
      <div class="switch-wrapper">
        <label
          class="switch-label"
          :class="{ 'switch-label-active': !showActive }"
          @click="showActive = false"
          >Неактивни</label
        >
        <div class="switch-container">
          <label class="switch">
            <input type="checkbox" v-model="showActive" />
            <span class="slider"></span>
          </label>
        </div>
        <label
          class="switch-label"
          :class="{ 'switch-label-active': showActive }"
          @click="showActive = true"
          >Активни</label
        >
      </div>
      <div class="btns desktop" v-if="tab === 'users'">
        <!-- OTPUSKS BUTTON -->
        <!-- <router-link to="/otpusks" class="btn btn-otpusks">
          <span class="mck2">j</span>
          Справка отпуски
        </router-link>-->
        <!-- NEW USER BUTTON -->
        <button class="btn btn-new" @click="openModal('isUserModalOpened')">
          <span class="mck">V</span>
          Нов потребител
        </button>
      </div>
      <!-- GROUPS BUTTONS -->
      <div class="btns desktop" v-else-if="tab === 'groups'">
        <button class="btn btn-new" @click="openModal('isGroupModalOpened')">
          <span class="mck2">6</span>
          Нова група
        </button>
      </div>
      <!-- POSITIONS BUTTONS -->
      <div class="btns desktop" v-else-if="tab === 'positions'">
        <button class="btn btn-new" @click="openModal('isPositionModalOpened')">
          <span class="mck2">s</span>
          Нова длъжност
        </button>
      </div>
    </header>
    <template v-if="tab === 'users'">
      <!-- DESKTOP TABLE WITH USERS (ACTIVE AND INACTIVE) -->
      <div class="table-wrapper desktop">
        <table class="table">
          <tbody>
            <tr
              v-for="user of searchFilter()"
              :key="user._id"
              :class="{ 'inactive-row': !showActive }"
              @click="editUser(user)"
            >
              <td class="td-user-name">
                <span class="mck">B</span>
                <span>
                  <strong class="nowrap">{{ user.name }}</strong>
                </span>
              </td>
              <td>{{ user.position ? user.position.name : "" }}</td>
              <td>{{ user.group ? user.group.name : "" }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.phone }}</td>
              <td>
                <span
                  v-if="user.permissions.isSuperAdmin"
                  class="permission-indicator superadmin-indicator mck2"
                  >J</span
                >
                <span
                  v-if="user.permissions.isAdmin"
                  class="permission-indicator admin-indicator"
                  >Администратор</span
                >
                <span
                  v-if="user.permissions.isHR"
                  class="permission-indicator hr-indicator"
                  >ЧР</span
                >
                <span
                  v-if="user.permissions.isReporter"
                  class="permission-indicator reporter-indicator"
                  >Отчетник</span
                >
                <span
                  v-if="user.permissions.isWorker"
                  class="permission-indicator worker-indicator"
                  >Работник</span
                >
                <span
                  v-if="user.permissions.isExternalWorker"
                  class="permission-indicator external-indicator"
                  >Външен работник</span
                >
                <span
                  v-for="role of user.roles"
                  :key="role._id"
                  v-show="!role.isMain"
                  class="permission-indicator extra_role-indicator"
                  >{{ role.name }}
                </span>

                <span v-if="user.isVisibleMain">👁️</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- MOBILE TABLE WITH USERS (ACTIVE AND INACTIVE) -->
      <div class="table-wrapper mobile">
        <table class="table">
          <tbody>
            <tr
              v-for="user of searchFilter()"
              :key="user._id"
              :class="{ 'inactive-row': !showActive }"
              @click="editUser(user)"
            >
              <td class="td-user-name">
                <div class="user-mobile">
                  <span>
                    <strong class="nowrap">{{ user.name }}</strong>
                  </span>
                </div>
                <div class="user-permissions">
                  <span
                    v-if="user.permissions.isSuperAdmin"
                    class="permission-indicator superadmin-indicator"
                    >J</span
                  >
                  <span
                    v-if="user.permissions.isAdmin"
                    class="permission-indicator admin-indicator"
                    >Администратор</span
                  >
                  <span
                    v-if="user.permissions.isHR"
                    class="permission-indicator hr-indicator"
                    >ЧР</span
                  >
                  <span
                    v-if="user.permissions.isReporter"
                    class="permission-indicator reporter-indicator"
                    >Отчетник</span
                  >
                  <span
                    v-if="user.permissions.isWorker"
                    class="permission-indicator worker-indicator"
                    >Работник</span
                  >
                  <span
                    v-if="user.permissions.isExternalWorker"
                    class="permission-indicator external-indicator"
                    >Външен работник</span
                  >
                  <span v-if="user.isVisibleMain">👁️</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- BUTTON NEW USER FOR MOBILE -->
      <footer class="modal-footer mobile">
        <div
          class="new-content-data-item-toggle-circle mobile"
          @click="openModal('isUserModalOpened')"
        >
          <span class="mck">V</span>
        </div>
      </footer>
    </template>
    <template v-else-if="tab === 'groups'">
      <div class="table-wrapper">
        <table class="table">
          <tbody>
            <tr
              v-for="g of filteredGroups"
              :class="{ 'inactive-row': !showActive }"
              :key="g._id"
              @click="editGroup(g._id)"
            >
              <td class="td-user-name">
                <span class="mck2">5</span>
                <span>
                  <strong>{{ g.name }}</strong>
                </span>
              </td>
              <td class="td-transparent td-widthless">
                {{ g.users || 0 }}
                {{ g.users === 1 ? "служител" : "служителя" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer class="modal-footer mobile">
        <div
          class="new-content-data-item-toggle-circle mobile"
          @click="openModal('isGroupModalOpened')"
        >
          <span class="mck2">6</span>
        </div>
      </footer>
    </template>
    <template v-else-if="tab === 'positions'">
      <div class="table-wrapper">
        <table class="table">
          <tbody>
            <tr
              v-for="p of filteredPositions"
              :class="{ 'inactive-row': !showActive }"
              :key="p._id"
              @click="editPosition(p._id)"
            >
              <td class="td-user-name">
                <span class="mck2">s</span>
                <span>
                  <strong>{{ p.name }}</strong>
                </span>
              </td>
              <td class="td-transparent">Ставка: {{ p.rate }} €/час</td>
              <td class="td-transparent td-widthless">
                {{ p.users || 0 }}
                {{ p.users === 1 ? "служител" : "служителя" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer class="modal-footer mobile">
        <div
          class="new-content-data-item-toggle-circle mobile"
          @click="openModal('isPositionModalOpened')"
        >
          <span class="mck2">s</span>
        </div>
      </footer>
    </template>
    <!-- USER MODAL -->
    <transition name="fade">
      <appUserModal v-if="isUserModalOpened" :idToEdit="idToEdit" />
    </transition>
    <!-- GROUP MODAL -->
    <transition name="fade">
      <UserGroupModal
        v-if="isGroupModalOpened"
        :id="groupToEdit"
        @close="closeUserGroupModal"
      />
    </transition>
    <transition name="fade">
      <UserPositionModal
        v-if="isPositionModalOpened"
        :id="positionToEdit"
        @close="closeUserPositionModal"
      />
    </transition>
  </main>
</template>

<script>
import UserModal from "./shared/UserModal";
import UserGroupModal from "./shared/UserGroupModal";
import UserPositionModal from "./shared/UserPositionModal";
import { mapGetters } from "vuex";
import { getAccess } from "./mixins/getAccess";
export default {
  components: {
    appUserModal: UserModal,
    UserGroupModal,
    UserPositionModal,
  },
  data() {
    return {
      showActive: true,
      isUserModalOpened: false,
      isGroupModalOpened: false,
      isPositionModalOpened: false,
      idToEdit: "",
      groupToEdit: "",
      positionToEdit: "",
      users: [],
      groups: [],
      positions: [],
      tab: "users",
      search: "",
    };
  },
  watch: {
    tab(to) {
      if (to === "users") {
        this.getUsers();
      } else if (to === "groups") {
        this.getGroups();
      } else if (to === "positions") {
        this.getPositions();
      }
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
    // Filtered by active
    filteredUsers() {
      return this.users.filter((u) => {
        return u.isActive === this.showActive;
      });
    },
    filteredGroups() {
      return this.groups.filter((g) => {
        return g.isActive === this.showActive && g.name.toLowerCase().includes(this.search);
      });
    },
    filteredPositions() {
      return this.positions.filter((p) => {
        return p.isActive === this.showActive && p.name.toLowerCase().includes(this.search);
      });
    },
  },
  methods: {
    // Filter users for searching by name
    searchFilter() {
      let filteredusers = this.filteredUsers;
      return filteredusers.filter((u) => {
        return u.name.toLowerCase().includes(this.search) || u.username.toLowerCase().includes(this.search);
      });
    },
    editUser(u) {
      if (getAccess("users_info", "users", true)) {
        // if (!this.getUser.permissions.isSuperAdmin) {
        //   this.$snotify.error("Нямате права да редактирате акаунти.");
        //   return;
        // }
        // if (
        //   u.permissions.isSuperAdmin &&
        //   !this.getUser.permissions.isSuperAdmin
        // ) {
        //   this.$snotify.error(
        //     "Нямате права да редактирате акаунта на главен администратор."
        //   );
        //   return;
        // }
        this.idToEdit = u._id;
        this.isUserModalOpened = true;
      }
    },
    getUsers() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users?positionandgroup=true`)
        .then((response) => {
          this.users = response.data;
          this.$store.dispatch("stopLoading");
        });
    },
    getGroups() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group`)
        .then((response) => {
          this.groups = response.data;
          this.groups.map((g) => {
            this.$http
              .get(`${process.env.VUE_APP_BASE_URI}/group/count-users/${g._id}`)
              .then((res) => {
                this.$set(g, "users", res.data);
              });
          });
          this.$store.dispatch("stopLoading");
        });
    },
    editGroup(g) {
      if (getAccess("users_info", "users", true)) {
        // if (!this.getUser.permissions.isSuperAdmin) {
        //   this.$snotify.error("Нямате права да редактирате групи.");
        //   return;
        // }
        this.groupToEdit = g;
        this.isGroupModalOpened = true;
      }
    },
    closeUserGroupModal(update) {
      this.isGroupModalOpened = false;
      this.groupToEdit = "";
      if (update) {
        this.getGroups();
      }
    },
    openModal(modalName) {
      if (getAccess("users_info", "users", true)) {
        this[modalName] = true;
      }
    },
    getPositions() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/position`)
        .then((response) => {
          this.positions = response.data;
          this.positions.map((p) => {
            this.$http
              .get(
                `${process.env.VUE_APP_BASE_URI}/position/count-users/${p._id}`
              )
              .then((res) => {
                this.$set(p, "users", res.data);
              });
          });
          this.$store.dispatch("stopLoading");
        });
    },
    editPosition(p) {
      if (getAccess("users_info", "users", true)) {
        // if (!this.getUser.permissions.isSuperAdmin) {
        //   this.$snotify.error("Нямате права да редактирате длъжности.");
        //   return;
        // }
        this.positionToEdit = p;
        this.isPositionModalOpened = true;
      }
    },
    closeUserPositionModal(update) {
      this.isPositionModalOpened = false;
      this.positionToEdit = "";
      if (update) {
        this.getPositions();
      }
    },
  },
  mounted() {
    this.getUsers();

    this.$on("closeUserModal", (result) => {
      this.isUserModalOpened = false;
      this.idToEdit = "";
      // if result.isEdited = true, this means something is changed and we get the users again
      if (result.isEdited) {
        this.users = [];
        this.getUsers();
      }
    });
  },
  updated() {
    // Handle search input
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data;
    });
  },
  destroyed() {
    this.$off("closeUserModal");
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
}
.switch-wrapper {
  align-items: center;
  display: flex;
}
.switch {
  margin: 0 8px;
}
.switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
}
.switch-label-active {
  opacity: 1;
}
td {
  width: 20%;
}
.table tr td:last-child {
  white-space: nowrap;
}
.table tr .td-widthless {
  width: 1%;
}
.table tr .td-transparent {
  color: rgba(0, 0, 0, 0.7);
}
.td-user-name span {
  vertical-align: middle;
}
.td-user-name .mck,
.td-user-name .mck2 {
  margin: 0 7px 0 4px;
}

.desktop {
  display: flex;
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .users-header {
    justify-content: center;
  }
  .tabs {
    margin-right: 10px;
  }
  .table-wrapper {
    overflow: auto;
  }
  .table td {
    padding: 10px;
  }
  .user-mobile {
    display: flex;
    justify-content: center;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }
  .user-permissions {
    display: flex;
    justify-content: center;
    padding-bottom: 0.5em;
  }
  .new-content-data-item-toggle-circle {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.otpusks {
    background-color: #217346;
    bottom: 80px;
  }
  .new-content-data-item-toggle-circle.otpusks .mck2 {
    border: 1px solid #217346;
  }
  .modal-footer {
    background-color: #f0f0f7;
    height: 75px;
    padding: 0px;
  }
}
</style>
